import React, { useState, useEffect } from 'react';
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi';
import { motion } from 'framer-motion';

// import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor, client } from '../../client';
import './Testimonial.scss';

const Testimonial = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [testimonials, setTestimonials] = useState([]);
  const [companies, setCompanies] = useState([]);

  const handleClick = (index) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    const query = '*[_type == "testimonials"]';
    const companiesQuery = '*[_type == "companies"]';

    client.fetch(query).then((data) => {
      setTestimonials(data);
    });

    client.fetch(companiesQuery).then((data) => {
      setCompanies(data);
    });
  }, []);

  return (
    <>

      <h2 className="testimonial__text" id="testimonials">Dream <span>Companies</span></h2>

      {/* <h5 Click className="hire-text">Hover Over Them!</h5> */}
  
      <div className="app__testimonial-companies app__flex">
        {companies.map((companie) => (
          <motion.div
            whileInView={{ opacity: [0, 1] }}
            transition={{ duration: 0.5, type: 'tween' }}
            key={companie._id}
          >
            <img src={urlFor(companie.imgUrl)} alt={companie.name} />
          </motion.div>
        ))}
      </div>
    </>
  );
};

export default Testimonial;